import type { Logger } from "@expert/logging";

import ky from "ky";

import type { DefaultPayload } from "./types";

import { defaultHeaders, defaultTimeoutInMS } from "../types";

type ActivateDevicePayload = DefaultPayload & {
    manualDeviceInfo?: {
        imei: string;
        iccid: string;
    };
};

export const activateDevice = async (
    ssoAccessToken: string,
    payload: ActivateDevicePayload,
    verifiedCustomerTokenOrExtraAuthToken: string,
    logger: Logger,
) => {
    try {
        const url = `${import.meta.env.VITE_API_BASE_URL}/api/device-activation/v1/activate`;
        const resp = await ky.post(url, {
            headers: {
                ...defaultHeaders,
                Authorization: `Bearer ${ssoAccessToken}`,
            },
            json: { ...payload, token: verifiedCustomerTokenOrExtraAuthToken },
            timeout: defaultTimeoutInMS,
        });

        const { result } = await resp.json<{ result: string }>();
        return { wasSuccessful: result === "SUCCESS" };
    } catch (error) {
        logger.warn({ error }, `Error: Could not activate device.`);
        return { wasSuccessful: false };
    }
};
